import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import writingService from '@/services/writing/writingService';
import {
    fetchWritingPromptsRequest,
    fetchWritingPromptsSuccess,
    fetchWritingPromptsFailure,
    createWritingSessionRequest,
    createWritingSessionSuccess,
    createWritingSessionFailure,
    fetchWritingSessionByIdRequest,
    fetchWritingSessionByIdSuccess,
    fetchWritingSessionByIdFailure,
    submitWritingAnswerRequest,
    submitWritingAnswerSuccess,
    submitWritingAnswerFailure,
    submitWritingRequest,
    submitWritingSuccess,
    submitWritingFailure,
    fetchWritingPromptByIdRequest,
    fetchWritingPromptByIdFailure,
    fetchWritingPromptByIdSuccess,
} from '../slices/writing/writingSlice';
import { history } from '@/utils/browserHistory';
// === WRITING PROMPTS ===
function* fetchWritingPromptsSaga(action: PayloadAction<any>): SagaIterator {
    try {
        const response = yield call(writingService.getWritingPrompts, action.payload);
        yield put(fetchWritingPromptsSuccess(response));
    } catch (error: any) {
        yield put(fetchWritingPromptsFailure(error.response?.data?.message || 'Failed to fetch writing prompts'));
    }
}

// === SUBMIT WRITING ANSWER ===
function* submitWritingAnswerSaga(
    action: PayloadAction<{
        prompt_id: string;
        content: string;
        word_count: number;
        time_spent_minutes: number;
    }>,
): SagaIterator {
    try {
        const response = yield call(writingService.submitWritingAttempt, {
            prompt_id: action.payload.prompt_id,
            content: action.payload.content,
            word_count: action.payload.word_count,
            time_spent_minutes: action.payload.time_spent_minutes,
        } as any);
        yield put(submitWritingAnswerSuccess(response));
    } catch (error: any) {
        yield put(submitWritingAnswerFailure(error.response?.data?.message || 'Failed to submit writing answer'));
    }
}

// === SUBMIT WRITING ===
function* submitWritingSaga(
    action: PayloadAction<{
        prompt_id: string;
        content: string;
        word_count: number;
        time_spent_minutes: number;
        session_id: string;
    }>,
): SagaIterator {
    try {
        const response = yield call(writingService.submitWriting, action.payload);
        yield put(submitWritingSuccess(response));
    } catch (error: any) {
        yield put(submitWritingFailure(error.response?.data?.message || 'Failed to submit writing'));
    }
}

// === CREATE WRITING SESSION ===
function* createWritingSessionSaga(
    action: PayloadAction<{
        prompt_id: string;
        session_type: string;
        difficulty_level: string;
    }>,
): SagaIterator {
    try {
        const response = yield call(writingService.createWritingSession, action.payload);
        yield put(createWritingSessionSuccess(response));
        // console.log('response', response);
        // window.location.href = `/student/writing-session?prompt_id=${action.payload.prompt_id}&session_id=${response?.id}`;
    } catch (error: any) {
        yield put(createWritingSessionFailure(error.response?.data?.message || 'Failed to create writing session'));
    }
}

// === FETCH WRITING SESSION BY ID ===
function* fetchWritingSessionByIdSaga(action: PayloadAction<string>): SagaIterator {
    try {
        const response = yield call(writingService.getWritingSessionById, action.payload);
        yield put(fetchWritingSessionByIdSuccess(response));
    } catch (error: any) {
        yield put(fetchWritingSessionByIdFailure(error.response?.data?.message || 'Failed to fetch writing session'));
    }
}

// === FETCH WRITING PROMPT BY ID ===
function* fetchWritingPromptByIdSaga(action: PayloadAction<string>): SagaIterator {
    try {
        const response = yield call(writingService.getWritingPromptById, action.payload);
        yield put(fetchWritingPromptByIdSuccess(response));
    } catch (error: any) {
        yield put(fetchWritingPromptByIdFailure(error.response?.data?.message || 'Failed to fetch writing prompt'));
    }
}

// === ROOT SAGA ===
export default function* writingSaga(): SagaIterator {
    yield takeLatest(fetchWritingPromptsRequest.type, fetchWritingPromptsSaga);
    yield takeLatest(submitWritingAnswerRequest.type, submitWritingAnswerSaga);
    yield takeLatest(submitWritingRequest.type, submitWritingSaga);
    yield takeLatest(createWritingSessionRequest.type, createWritingSessionSaga);
    yield takeLatest(fetchWritingSessionByIdRequest.type, fetchWritingSessionByIdSaga);
    yield takeLatest(fetchWritingPromptByIdRequest.type, fetchWritingPromptByIdSaga);
}
